import Vue from 'vue'
import VueRouter from 'vue-router'
import PublicLayout from '../components/PublicLayout.vue'
import Home from '../views/public/Home.vue'
import CheckIn from '../views/public/CheckIn.vue'
import Records from '../views/public/Records.vue'
import ParentLogin from '../views/public/ParentLogin.vue'
import About from '../views/public/About.vue'
import Privacy from '../views/public/Privacy.vue'
import Login from '../views/Login.vue'
import Layout from '../views/Layout.vue'
import Dashboard from '../views/Dashboard.vue'
import Enroll from '../views/Enroll.vue'
import Students from '../views/Students.vue'
import CheckInRecords from '../views/CheckInRecords.vue'
import ManualCheckIn from '../views/ManualCheckIn.vue'
import Settings from '../views/Settings.vue'
import PrivateStudents from '../views/private/PrivateStudents.vue'
import PrivatePunch from '../views/private/PrivatePunch.vue'
import PrivateRecords from '../views/private/PrivateRecords.vue'
import HourAudit from '../views/HourAudit.vue'
import GroupLesson from '../views/GroupLesson.vue'
import Notify from '../views/Notify.vue'
import Clubs from '../views/Clubs.vue'
import Coaches from '../views/Coaches.vue'

Vue.use(VueRouter)

const ADMIN_PATHS = [
  '/dashboard', '/enroll', '/students', '/coaches', '/check-in-records',
  '/manual-check-in', '/settings', '/private', '/hour-audit', '/checkin-kiosk',
  '/group-lesson', '/notify', '/clubs'
]

function adminRoute(path, name, component, meta) {
  return {
    path,
    component: Layout,
    children: [{ path: '', name, component, meta: meta || {} }]
  }
}

function openKioskWindow(courseType) {
  const raw = (localStorage.getItem('club_code') || '').trim()
  if (!raw) return
  const code = encodeURIComponent(raw)
  const type = Number(courseType) === 2 ? 2 : 1
  const base = window.location.href.split('#')[0]
  const hash = '#/kiosk?clubCode=' + code + '&courseType=' + type
  const win = window.open(base + hash, '_blank')
  if (!win && typeof window !== 'undefined') {
    window.location.hash = hash
  }
}

const routes = [
  {
    path: '/',
    component: PublicLayout,
    children: [
      { path: '', name: 'Home', component: Home },
      { path: 'checkin', name: 'CheckIn', component: CheckIn },
      { path: 'kiosk', name: 'KioskCheckIn', component: CheckIn, meta: { kiosk: true } },
      { path: 'records', name: 'Records', component: Records }
    ]
  },
  { path: '/parent/login', name: 'ParentLogin', component: ParentLogin },
  { path: '/about', name: 'About', component: About },
  { path: '/privacy', name: 'Privacy', component: Privacy },
  { path: '/login', name: 'Login', component: Login },
  // 侧栏「拍照签到」：打开大屏签到页，并留在管理后台（避免空白路由）
  {
    path: '/checkin-kiosk',
    beforeEnter(to, from, next) {
      openKioskWindow(to.query && to.query.courseType)
      next(from.path && from.path !== '/checkin-kiosk' ? from.fullPath : '/dashboard')
    }
  },
  adminRoute('/dashboard', 'Dashboard', Dashboard, { title: '工作台', subtitle: '先查课时，再报名或签到' }),
  adminRoute('/enroll', 'Enroll', Enroll, { title: '报名录入', subtitle: '新学员选大课、小课或年卡；已有档案报年卡会续期' }),
  adminRoute('/students', 'Students', Students, { title: '查课时', subtitle: '一眼看大课剩余、小课剩余、年卡有效期' }),
  adminRoute('/coaches', 'Coaches', Coaches, { title: '教练账号', subtitle: '开号后教练登录即可划课' }),
  adminRoute('/check-in-records', 'CheckInRecords', CheckInRecords, { title: '大课记录', subtitle: '拍照 / 选人历史' }),
  adminRoute('/manual-check-in', 'ManualCheckIn', ManualCheckIn, { title: '大课选人签到', subtitle: '搜索名单，可一次多人' }),
  adminRoute('/hour-audit', 'HourAudit', HourAudit, { title: '课时对账', subtitle: '核对充值与消耗流水' }),
  adminRoute('/group-lesson', 'GroupLesson', GroupLesson, { title: '大课接龙', subtitle: '发起场次 · 名单 · 调课时' }),
  adminRoute('/notify', 'Notify', Notify, { title: '发通知', subtitle: '训练计划 · 放假 · 上课提醒' }),
  adminRoute('/clubs', 'Clubs', Clubs, { title: '内容模块开关' }),
  adminRoute('/settings', 'Settings', Settings, { title: '系统设置', subtitle: '比对阈值 · 抵小课比例 · 课时不足提醒' }),
  // 旧书签 /private 小课首页已废弃，跳到工作台（功能已在工作台/侧栏直达）
  { path: '/private', redirect: '/dashboard' },
  adminRoute('/private/students', 'PrivateStudents', PrivateStudents, { title: '小课名单/充值', subtitle: '余额 · 带课教练可选填' }),
  adminRoute('/private/punch', 'PrivatePunch', PrivatePunch, { title: '小课选人签到', subtitle: '勾选到课学员，馆长可代消' }),
  adminRoute('/private/records', 'PrivateRecords', PrivateRecords, { title: '小课记录', subtitle: '搜索 · 删除' })
]

const router = new VueRouter({ routes })

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const isAdminRoute = ADMIN_PATHS.some(p => to.path === p || to.path.startsWith(p + '/'))
  const role = Number(localStorage.getItem('admin_role') || 1)
  const isPlatform = role === 9

  if (to.path === '/login') {
    next(token ? (isPlatform ? '/clubs' : '/dashboard') : undefined)
    return
  }
  if (isAdminRoute && !token) {
    next('/login')
    return
  }
  if (to.path === '/clubs' && token && !isPlatform) {
    next('/dashboard')
    return
  }
  next()
})

export default router
